module.exports = __webpack_public_path__ + "static/media/org.46aa029e.webp";